
export enum RentalMileageOption  {
    LOW = "LOW",
    STANDARD = "STANDARD",
    HIGH = "HIGH" 
};

export enum RentalInsuranceOption  {
    NONE = "NONE",
    BASIC = "BASIC",
    STANDARD = "STANDARD",
    PREMIUM = "PREMIUM" 
};

/*
export enum RentBookingStatusOld  {
    UNAVAILABLE = "UNAVAILABLE",
    NEW = "NEW",
    CONFIRMED = "CONFIRMED",
    PAID_PARTIAL = "PAID_PARTIAL",
    PAID_TOTAL = "PAID_TOTAL",
    COMPLETED = "COMPLETED",
    CANCELLED = "CANCELLED" 
};
*/
export enum BookingStatus {
  RESERVED = "RESERVED",
  DRAFT = "DRAFT",
  CANCELLED = "CANCELLED",
  SENT = "SENT",
  CONFIRMED = "CONFIRMED",
  PENDING_MODIF = "PENDING_MODIF",
  PAID_PARTIAL = "PAID_PARTIAL",
  PAID_TOTAL = "PAID_TOTAL",
  COMPLETED = "COMPLETED"
};

export enum BookingAction {
    CANCEL = "CANCEL",
    CANCEL_MODIF = "CANCEL_MODIF",
    EDIT = "EDIT",
    EDIT_MODIF = "EDIT_MODIF",
    SEND = "SEND",
    REOPEN = "REOPEN",
    CONFIRM = "CONFIRM",
    ACCEPT_MODIF = "ACCEPT_MODIF",
    COMPLETE = "COMPLETE"
}

export enum RentAction {
    CREATE = "CREATE",
    EDIT = "EDIT",
    PUBLISH = "PUBLISH",
    CLOSE = "CLOSE",
    SHARE = "SHARE",
    TOGGLE_FAV = "TOGGLE_FAV"
}

export interface BookingActionItem {
  action: BookingAction,
  title: string,
  icon?: string
};

export interface RentActionItem {
  action: RentAction,
  title: string,
  icon?: string
};

export class RentBasicData {

    public static rentalMileageOptions: any = [
    {
      code: RentalMileageOption.LOW, 
      desc: "Faible"
    },
    {
      code: RentalMileageOption.STANDARD,
      desc: "Standard"
    },
    {
      code: RentalMileageOption.HIGH,
      desc: "Maximum"
    }
  ];

  public static rentalInsuranceOptions: any = [
    {
      code: RentalInsuranceOption.BASIC,
      desc: "Basique"
    },

    {
      code: RentalInsuranceOption.PREMIUM,
      desc: "Premium"
    }
  ];

  public static bookingActionItems : BookingActionItem[] = [
        {
          action: BookingAction.CONFIRM,
          title: "Confirmer",
          icon: 'accept'
        },
        {
          action: BookingAction.ACCEPT_MODIF,
          title: "Accepter modif",
          icon: 'accept'
        },
        {
          action: BookingAction.CANCEL,
          title: "Annuler",
          icon: 'cancel'
        },
        {
          action: BookingAction.CANCEL_MODIF,
          title: "Annuler modif",
          icon: 'cancel'
        },
        {
          action: BookingAction.COMPLETE,
          title: "Compléter",
          icon: 'complete'
        },
        {
          action: BookingAction.EDIT,
          title: "Editer",
          icon: 'edit'
        },
        {
          action: BookingAction.EDIT_MODIF,
          title: "Editer modif",
          icon: 'edit'
        },
        {
          action: BookingAction.REOPEN,
          title: "Réouvrir",
          icon: 'open'
        },
        {
          action: BookingAction.SEND,
          title: "Envoyer",
          icon: 'send'
        }
    ];
  
}